import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const deviceInfoInitialState = {
  deviceModel: '',
  browser: '',
  browserVersion: '',
};

export const deviceInfoSlice = createSlice({
  name: 'deviceInfo',
  initialState: deviceInfoInitialState,
  reducers: {
    updateDeviceInfo: (state, action) => {
      state.deviceModel = action.payload.deviceModel || '';
      state.browser = action.payload.browser || '';
      state.browserVersion = action.payload.browserVersion || '';
    },
  },
  extraReducers: {},
});

const { updateDeviceInfo } = deviceInfoSlice.actions;
export function useDeviceStore() {
  const deviceModel = useSelector((state) => state.deviceModel);
  const browser = useSelector((state) => state.browser);
  const browserVersion = useSelector((state) => state.browserVersion);

  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    deviceModel,
    browser,
    browserVersion,

    // DOCS: Write sync methods here
    updateDeviceInfo: (payload) => dispatch(updateDeviceInfo(payload)),
  };
}

export default deviceInfoSlice.reducer;
